import { Alert } from '@itds/elements/index.js';
import PropTypes from 'prop-types';
import React from 'react';

const Notification = ({ type, message, details = [] }) => {
  return (
    <Alert type={type}>
      <div>{message}</div>
      {details.map(it => (
        <div>{it}</div>
      ))}
    </Alert>
  );
};

Notification.propTypes = {
  details: PropTypes.arrayOf(PropTypes.string),
  message: PropTypes.string,
  type: PropTypes.string
};

export default Notification;
